import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Legacy route — redirects to the unified admin console (Deals tab).
 * Keeps existing links working. See /app/frontend/src/pages/AdminDashboard.jsx.
 */
export default function AdminDeals() {
  const navigate = useNavigate();
  useEffect(() => { navigate("/admin?tab=deals", { replace: true }); }, [navigate]);
  return null;
}
